.searchContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
}

.searchInput {
  min-width: 20rem;
  width: 100%;
}

.spinnerContainer {
  margin-left: 15px;
}